import { PhotoCheckProblem } from '@/types/photo-check.type';

// Words for "not done" that fit the task, from the task's title. Used when the photo check found the task
// not done but could not say why with confidence.
const TITLE_RULES: { test: RegExp; label: string }[] = [
  { test: /\bempt(y|ied|ying)\b/i, label: 'Not empty' },
  { test: /\b(turn|switch)(ed)?\s+off\b/i, label: 'Still on' },
  { test: /\block(ed)?\b/i, label: 'Not locked' },
  { test: /\b(replenish|refill|restock|stock)/i, label: 'Not refilled' },
  {
    test: /\b(straighten|organi[sz]e|tidy|arrange|stack|fold)/i,
    label: 'Not tidy'
  },
  {
    test: /\b(clean|wipe|wiped|mop|sweep|vacuum|dust|disinfect|saniti[sz]e|scrub|wash|polish|spill)/i,
    label: 'Not clean'
  }
];

/**
 * A short label and a line of help for a task the photo shows is not done. Uses what the photo check saw
 * (problem) when it was sure, otherwise words from the task title, otherwise "Not done".
 */
export function notDoneLabel(
  problem: PhotoCheckProblem | null | undefined,
  title: string | null | undefined
): { label: string; hint: string } {
  const isEmptyTask = /\bempt(y|ied|ying)\b/i.test(title || '');
  switch (problem) {
    case 'rubbish':
      return isEmptyTask
        ? { label: 'Not empty', hint: 'Rubbish is still in it' }
        : { label: 'Rubbish left', hint: 'Rubbish or items are still there' };
    case 'dirty':
      return { label: 'Not clean', hint: 'Dirt, dust or stains can be seen' };
    case 'messy':
      return { label: 'Not tidy', hint: 'Things are out of place' };
    case 'not_visible':
      return {
        label: "Can't see it",
        hint: 'It is not in the photo. Point the camera at it and retake'
      };
  }
  const rule = TITLE_RULES.find(r => r.test.test(title || ''));
  return {
    label: rule?.label || 'Not done',
    hint: 'Not seen done in the photo'
  };
}
